import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import routes from '../../../../routes';
import { projectActions, projectSelectors } from '../../../../store/modules/project';
const { Router } = routes;

const useFetchProjectById = (projectId = '') => {
  const dispatch = useDispatch();
  const isMountedRef = useRef({});

  const project = useSelector(state => projectSelectors.selectProjectById(state, projectId));
  const isPending = useSelector(projectSelectors.selectCurrentProjectPending);
  const projectError = useSelector(projectSelectors.selectCurrentProjectError);

  useEffect(() => {
    if (!project && projectId && !projectError) {
      dispatch(projectActions.fetchProject(projectId));
    }

    return () => {
      project && !projectError && dispatch(projectActions.clearCurrentProject());
    };
  }, [projectId, project, isMountedRef.current, projectError]);

  useEffect(() => {
    if (!projectError) return;

    projectError && Router.pushRoute('404');
  }, [projectError]);

  return [project, isPending] as const;
};

export default useFetchProjectById;
